import { GET, POST, PUT, DELETE } from '../utils/http'
let charturl = "https://api.live.lejian.com/" // 聊天室测试路径
let url = 'https://api.health.lejian.com/' // uat地址
let BASE_URL= 'https://api.client.lejian.com';
let recom_url = "https://recom.uat.lejian.com/recommend/selfPaidPackCastrated"

// 收银台url
export const pay_url = 'https://open-cashier.lejian.com/cashier/pc/?order_no='
    // 页面访问URL
export const access_URL = 'https://exam.58tc.lejian.com/pc/#/'
    // 聊天url
export const chart_URL = 'wss://api.chat.lejian.com?auth='
    // 阿里云客服链接
export const kf_URL = 'https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1M5dvuy&scene=SCE00008843'


// 查看本人信息
export const selectOne = param => {
    return GET(`${url}/appointment/contacts/one`);
};

//投诉建议
export const examFeedback = (param) => {
        return POST(`${url}exam/feedback/`, param)
    }
    //登录1
export const login = (param) => {
        return GET(`${url}access/58/sso/`, param)
    }
    //获取用户信息2
export const getUser = () => {
        return GET(`${url}account/profile/`)
    }
    //获取体检人列表3
export const getPhysical = () => {
        return GET(`${url}relatives/`)
    }
    //添加体检人4
export const addPhysical = (param) => {
        return POST(`${url}relatives/`, param)
    }
    //编辑体检人5
export const editPhysical = (param, id) => {
        return PUT(`${url}relatives/${id}/`, param)
    }
    // 编辑员工信息6
export const editPhysicalStaff = (param, id) => {
        return PUT(`${url}mt/relatives/${id}/`, param)
    }
    //删除体检人7
export const deletePhysical = (id) => {
        return DELETE(`${url}relatives/${id}/`)
    }
    //订单列表8
export const orderList = (param) => {
        return GET(`${url}orders/`, param)
    }
    //订单详情9
export const orderDetail = (order_no) => {
        return GET(`${url}orders/${order_no}/`)
    }
    //订单详情9(2)
export const orderDetail1 = (subOrderNo) => {
    return GET(`${url}/exam/satisfaction_survey/userExam/order/getExamOrderInfo/`, {
        subOrderNo: subOrderNo
    });
};
// 体检报告列表10
export const reportList = () => {
        return GET(`${url}reports/`, )
    }
    //项目列表11
export const projectList = () => {
        return GET(`${url}exam/projects/`)
    }
    //体检权益12
export const getbenefit = (param) => {
        return GET(`${url}relatives/benefit/`, param)
    }
    //城市列表13
export const cityList = (batch) => {
        return GET(`${url}batch/${batch}/cities/`)
    }
    //机构列表14
export const brandList = (param, batch) => {
        return GET(`${url}batch/${batch}/brands/`, param)
    }
    //分院列表15
export const hospitalList = (param, batch) => {
        return GET(`${url}batch/${batch}/branches/`, param)
    }
    //排期列表16
export const dateList = (param, id) => {
        return GET(`${url}hospitals/${id}/schedule/`, param)
    }
    //套餐列表17
export const comboList = (param, id) => {
        return GET(`${url}hospitals/${id}/combos/`, param)
    }
    //免费加项列表18
export const packagesList = (param, id) => {
        return GET(`${url}hospitals/${id}/extra/packages/`, param)
    }
    //自费加项列表19
export const self_paid_packagesList = (param, id) => {
        return GET(`${url}hospitals/${id}/self/paid/packages/`, param)
    }
    //预约20
export const subscribe = (param) => {
        return POST(`${url}orders/`, param)
    }
    //上传体检报告21
export const uploadReport = (param, config) => {
        return POST(`${url}reports/uploading/`, param, config)
    }
    //实时计算价格22
export const limit = (param) => {
        return POST(`${url}realtime/price/`, param)
    }
    //实时计算价格23
export const cancelOrder = (order_no) => {
        return DELETE(`${url}orders/${order_no}/`)
    }
    //套餐详情24
export const comboDetail = (param, hospital, combo) => {
        return GET(`${url}hospitals/${hospital}/combos/${combo}/`, param)
    }
    //分院详情25
export const hospitalDetail = (id) => {
        return GET(`${url}hospitals/${id}/`)
    }
    //获取改期的排期26
export const orderDateList = (order_no) => {
        return GET(`${url}orders/${order_no}/schedule/`)
    }
    //获取改期的排期27
export const orderChangeTime = (param, order_no) => {
        return PUT(`${url}orders/${order_no}/`, param)
    }
    // 二次授权28
export const authorize = (param) => {
        return POST(`${url}reports/second/authorize/`, param)
    }
    //判断本人是否体检29
export const selforder = () => {
        return GET(`${url}selforder/`)
    }
    //获取订单状态的数量30
export const getStatusNum = () => {
        return GET(`${url}orders/statistics/`)
    }
    //获取问卷结构31
export const surveyDetail = () => {
        return GET(`${url}survey/abb/detail/`)
    }
    //上传满意度调查32
export const surveyUpload = (param) => {
        return POST(`${url}survey/abb/upload/`, param)
    }
    //获取聊天token33
export const chartGettoken = (param) => {
        return GET(`${url}access/lecarechat/get/`)
    }
    //获取聊天用户信息34
export const chartGetuserInfo = (param) => {
        return GET(`${charturl}chatroom/get_userinfo`)
    }
    //获取聊天记录35
export const chartGetchartlist = (param) => {
        return GET(`${charturl}chatroom/chatLog/${param}?current=1`)
    }
    //发送文件接口
export const sendfile = (obj) => {
    return POST(charturl + `chatroom/upload`, obj)
}

//报销申请人的信息36
export const proposerInformation = () => {
        return GET(`${url}exam/invoice/submit/`)
    }
    //四级地址37
export const levelAdderss = (id) => {
        return GET(`${url}exam/cities/${id}/`)
    }
    //提交报销申请38
export const reimbursement = (param, config) => {
        return POST(`${url}exam/invoice/submit/`, param, config)
    }
    //报销权限查看39
export const authority = () => {
        return GET(`${url}exam/invoice/check/`)
    }
    // 报销上传文件40
export const reimbursementUpload = (param, config) => {
        return POST(`${url}exam/invoice/upload/imgs/`, param, config)
    }
    // 开票信息41
export const reimburseTitle = (project_id) => {
        return GET(`${url}exam/invoice/title/${project_id}/`)
    }
    // 获取纸质发票邮寄地址42
export const mailingAddress = (project_id) => {
        return GET(`${url}exam/invoice/receiver/${project_id}/`)
    }
    //获取报销单列表43
export const invoiceList = () => {
        return GET(`${url}exam/invoice/list/`)
    }
    //获取报销单详情44
export const invoiceDetail = (invoice_no) => {
        return GET(`${url}exam/invoice/detail/${invoice_no}/`)
    }
    //导出报销单45
export const exportInvoice = `${url}exam/invoice/export/`
    //修改报销单46
export const reimbursementEdit = (invoice_no, param, config) => {
        return POST(`${url}exam/invoice/update/${invoice_no}/`, param, config)
    }
    //获取企业报销47
export const noticeDetail = (project_id) => {
        return GET(`${url}exam/invoice/knows/${project_id}/`)
    }
    //中间页接口
export const statusOrder = (order_no) => {
        return GET(`${url}exam/orders/${order_no}/status/`)
    }
    //专家推荐
export const recommend = (param) => {
    return POST(`${recom_url}`, param)
}

//配置化接口
export  const  config  =   ()  =>  {  
    return  GET(`${BASE_URL}/project/site/config`)
  };


// WEBPACK FOOTER //
// ./src/utils/api.js